module.exports = "../../../../platform/assets/pageMainIcon/simple_danjuweihulei8.svg";